import labExpertFinder from '../../components/labExpertFinder';

document.querySelectorAll('[data-comp-lab-expert-finder]')
  .forEach(el => new labExpertFinder(el));

